import React, { useState, useEffect } from 'react';
import './AlphaModal.css';

const AlphaModal: React.FC = () => {
  const [showAlphaModal, setShowAlphaModal] = useState(false);

  useEffect(() => {
    // 检查今天是否已经显示过alpha modal
    const today = new Date().toDateString();
    const lastShownDate = localStorage.getItem('alphaModalLastShown');
    
    if (lastShownDate !== today) {
      setShowAlphaModal(true);
    }
  }, []);

  const handleClose = () => {
    setShowAlphaModal(false);
    // 记录今天已经显示过
    const today = new Date().toDateString();
    localStorage.setItem('alphaModalLastShown', today);
  };

  if (!showAlphaModal) return null;

  return (
    <div className="alpha-modal-overlay">
      <div className="alpha-modal">
        <div style={{
          margin: '0 0 24px 0',
          color: '#f8f4e6',
          fontSize: '1.08rem',
          lineHeight: 1.6,
          textAlign: 'center',
        }}>
          This app is currently in <b>ALPHA</b> testing.<br/>
          Features may change and data may be reset at any time.<br/>
          We appreciate your feedback!
        </div>
        <button
          style={{
            margin: '0 auto',
            display: 'block',
            background: 'linear-gradient(90deg, #f5d7a1, #29cbe8)',
            color: '#222',
            border: 'none',
            borderRadius: 24,
            width: 120,
            height: 40,
            fontSize: '1.08rem',
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
            transition: 'all 0.2s ease',
          }}
          onClick={handleClose}
          onMouseOver={e => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.10)';
          }}
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default AlphaModal; 